export default "__VITE_ASSET__55c87634__"